import React from "react";
import chexLogo from "../../Assets/ChexIcon.png";
import "./style.css";

const AppLoadingScreen = () => (
  <div className="app-loading-screen" role="status" aria-label="Loading">
    <img
      className="app-loading-screen__logo"
      src={chexLogo}
      alt="Chex.AI"
    />
  </div>
);

export default AppLoadingScreen;
